import { getDocument } from '@jira/ssr__browser-globals/src/getDocument.tsx';

/**
 * Extracts and compiles key performance metrics from the DOM to assess server response times and request handling efficiency.
 * This includes metrics like server duration, trace IDs, concurrency levels, and timing details, which are crucial for analyzing server behavior and identifying potential bottlenecks.
 */
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const getServerDurationMetrics = (): Record<string, any> => {
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	const metrics: Record<string, any> = {};
	try {
		const doc = getDocument();
		if (!doc) {
			return metrics;
		}

		// server duration metric is buried in a hidden form near end of </body>

		const serverDurationElem = doc.querySelector(
			'#jira_request_timing_info [title="jira.request.server.time"]',
		);
		if (serverDurationElem) {
			// oxlint-disable-next-line typescript/consistent-type-assertions
			const serverDuration = Number((serverDurationElem as HTMLInputElement).value);
			if (serverDuration > 0) {
				metrics.serverDuration = Math.round(serverDuration);
			}
		}

		const serverTraceIdElem = doc.querySelector(
			'#jira_request_timing_info [title="jira.request.trace.id"]',
		);
		if (serverTraceIdElem) {
			// oxlint-disable-next-line typescript/consistent-type-assertions
			const serverRequestTraceId = (serverTraceIdElem as HTMLInputElement).value;
			metrics.serverRequestTraceId = serverRequestTraceId;
		}

		const serverTraceSampledElem = doc.querySelector(
			'#jira_request_timing_info [title="jira.request.sampled"]',
		);
		if (serverTraceSampledElem) {
			// oxlint-disable-next-line typescript/consistent-type-assertions
			const serverRequestTraceSampled = (serverTraceSampledElem as HTMLInputElement).value;
			switch (serverRequestTraceSampled) {
				case 'true':
					metrics.serverRequestTraceSampled = true;
					break;
				case 'false':
					metrics.serverRequestTraceSampled = false;
					break;
				default:
					metrics.serverRequestTraceSampled = null;
					break;
			}
		}

		const concurrentRequestsElem = doc.querySelector(
			'#jira_request_timing_info [name="jira.request.concurrent.requests"]',
		);
		if (concurrentRequestsElem) {
			// oxlint-disable-next-line typescript/consistent-type-assertions
			const concurrentRequests = (concurrentRequestsElem as HTMLInputElement).value;
			metrics.concurrentRequests = concurrentRequests;
		}

		const serverRequestStartTimeElem = doc.querySelector(
			'#jira_request_timing_info [name="jira.request.start.millis"]',
		);
		if (serverRequestStartTimeElem) {
			// oxlint-disable-next-line typescript/consistent-type-assertions
			const serverRequestStartTime = (serverRequestStartTimeElem as HTMLInputElement).value;
			metrics.serverRequestStartTime = serverRequestStartTime;
		}

		const frontendFlushStartTimeElem = doc.querySelector(
			'#jira_request_timing_info [name="jira.request.frontend.flush.start"]',
		);
		if (frontendFlushStartTimeElem) {
			// oxlint-disable-next-line typescript/consistent-type-assertions
			const frontendFlushStartTime = (frontendFlushStartTimeElem as HTMLInputElement).value;
			metrics.frontendFlushStartTime = frontendFlushStartTime;
		}
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (ignored: any) {
		/* noop */
	}
	return metrics;
};
